import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#252525",
  d: "M15.025 5.741a1.44 1.44 0 0 1-.457-1.101 3.11 3.11 0 0 0-1.96-2.986 3.1 3.1 0 0 0-1.24-.211 1.5 1.5 0 0 1-1.104-.461 3.094 3.094 0 0 0-4.522 0 1.5 1.5 0 0 1-1.103.457 3.05 3.05 0 0 0-2.293.907 3.1 3.1 0 0 0-.904 2.294 1.44 1.44 0 0 1-.46 1.101 3.094 3.094 0 0 0 0 4.521 1.44 1.44 0 0 1 .456 1.102 3.09 3.09 0 0 0 3.197 3.197 1.48 1.48 0 0 1 1.104.457 3.094 3.094 0 0 0 4.522 0 1.47 1.47 0 0 1 1.103-.457 3.09 3.09 0 0 0 3.198-3.197 1.44 1.44 0 0 1 .457-1.102 3.093 3.093 0 0 0 0-4.52zM6.11 11.063a.826.826 0 0 1-1.168-1.168L9.898 4.94a.826.826 0 0 1 1.168 1.168zm4.373-.17a1.238 1.238 0 1 1-2.476 0 1.238 1.238 0 0 1 2.476 0M5.525 5.11a1.239 1.239 0 1 1 2.477 0 1.239 1.239 0 0 1-2.477 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }